import cs from 'classnames';

import { colors, padding, sizes } from './lib/getClasses';

/**
 * @param {Object} props
 * @param {keyof sizes} props.size
 * @param {keyof colors} props.color
 * @param {string} [props.className]
 */

const Dot = ({ size = 'md', color = 'primary', className }) => {
  return (
    <div
      className={cs(
        'flex items-center justify-center rounded-full bg-white shadow-[0px_0px_4px_rgba(0,0,0,0.12)]',
        padding[size],
        className
      )}>
      <div className={cs('rounded-full', sizes[size], colors[color])} />
    </div>
  );
};

export default Dot;
